export const ROUTE_CONSTANTS = {
    PORTFOLIO: '/portfolio',
    CONTACTS: '/contacts',
    SERVICES: '/services',
    ABOUT_US: '/about-us',
}

export const LANG_CONSTANTS = {
    HOME: ["HOME", "ՀԻՄՆԱԿԱՆ"],
    PORTFOLIO: ["PORTFOLIO", "ՊՈՐՏՖՈԼԻՈ"],
    SERVICES: ["SERVICES", "ՍԵՐՎԻՍ"],
    ABOUT_US: ["ABOUT US", "ՄԵՐ ՄԱՍԻՆ"],
    CONTACTS: ["CONTACTS", "ԴԻՄԵԼ"],
    LANG: ["ՀԱՅ", "ENG"],
    LANGUAGE: ["ՀԱՅԵՐԵՆ", "ENGLISH"],
    MENU: ["MENU", "ՑԱՆԿ"]
}